// extracted by mini-css-extract-plugin
export default {"PfsArticleShow":"PFSArticleShow_PfsArticleShow__U7X+z"};